<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-8">
                <div class="text-primary p-4">
                  <h5 class="text-primary">{{ $t('pages.reset_password.title') }}</h5>
                </div>
              </div>
              <div class="col-4 align-self-end">
                <img
                    src="@/assets/images/login/reset_password.svg"
                    alt
                    class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="38"/>
                  </span>
                </div>
              </router-link>
            </div>

            <div class="p-2">
              <validation-error :error="error" v-if="isResetError"/>
              <form @submit.prevent="tryToReset">
                <form @keydown.enter="reset">

                  <b-form-group
                      class="mb-3"
                      id="input-group-2"
                      :label="$t('pages.reset_password.password')"
                      label-for="password"
                  >
                    <b-form-input
                        id="password"
                        v-model="password"
                        type="password"
                        :placeholder="$t('pages.reset_password.password_placeholder')"
                        :class="{'is-invalid': submitted && $v.password.$error}"
                    ></b-form-input>
                    <div
                        v-if="submitted && $v.password.$error"
                        class="invalid-feedback"
                    >
                      <span v-if="!$v.password.required">
                        {{ $t('pages.reset_password.validations.password_required') }}
                      </span>
                      <span v-if="!$v.password.minLength">
                        {{
                          $t('pages.reset_password.validations.password_max', {max: $v.password.$params.maxLength.max})
                        }}
                      </span>
                      <span v-if="!$v.password.maxLength">
                        {{ $t('pages.reset_password.password_placeholder', {min: $v.password.$params.minLength.min}) }}
                      </span>
                    </div>
                  </b-form-group>

                  <b-form-group
                      class="mb-3"
                      id="input-group-2"
                      :label="$t('pages.reset_password.confirm_password')"
                      label-for="confirm"
                  >
                    <b-form-input
                        id="confirm"
                        v-model="repeatPassword"
                        type="password"
                        :placeholder="$t('pages.reset_password.confirm_password_placeholder')"
                        :class="{'is-invalid': submitted && $v.repeatPassword.$error}"
                    ></b-form-input>
                    <div
                        v-if="submitted && $v.repeatPassword.$error"
                        class="invalid-feedback"
                    >
                      <span v-if="!$v.repeatPassword.required">
                        {{ $t('pages.reset_password.validations.confirm_password_required') }}
                      </span>
                      <span v-if="!$v.repeatPassword.sameAsPassword">
                        {{ $t('pages.reset_password.validations.same_password') }}
                      </span>
                    </div>
                  </b-form-group>

                  <div class="mt-5 d-grid">
                    <b-button @click="tryToReset" variant="primary" :disabled="loading">
                      <b-spinner v-if="loading" small/>
                      <i v-else class="mdi mdi-content-save"></i>
                      {{ $t('pages.reset_password.save') }}
                    </b-button>
                  </div>
                </form>

              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <login-footer/>
      </div>

      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<script>
import Layout from "../../../layouts/auth";

import {maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";
import LoginFooter from "./LoginFooter";
import AuthService from "../../../../Services/Api/AuthService";
import queryString from 'query-string'
import ValidationError from "../../../../components/widgets/ValidationError";

export default {
  name: "ForgotPassword",
  components: {
    ValidationError,
    LoginFooter,
    Layout,
  },
  page() {
    return {
      title: this.$t('pages.reset_password.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      password: "",
      repeatPassword: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      query: null,
      loading: false
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  methods: {
    tryToReset() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.tryingToReset = true;
        this.isResetError = null;
        this.loading = true
        const vm = this

        AuthService.resetPassword({
          payload: {
            password: vm.password,
            token: vm.query.token,
            password_confirmation: vm.repeatPassword
          }
        }, queryString.stringify(vm.query)).then(function () {
          vm.passwordSuccess = true
          vm.tryingToReset = false;
          vm.isResetError = false;
          vm.$router.push({name: 'login-form'})
        }).catch(err => {
          vm.tryingToReset = false;
          vm.error = err.data
          vm.isResetError = true;
        }).finally(() => {
          vm.loading = false
        })
      }
    },
  },
  created() {
    this.query = this.$route.query

    if (!this.query.email || !this.query.token || !this.query.signature || !this.query.expires) {
      this.$router.push({name: 'login'})
    }
  }
};
</script>

<style lang="scss" module></style>
